<template>
  <BaseNavbar :page_navigation="navigation" />
</template>

<script>
import BaseNavbar from '@/components/navbar/BaseNavbar.vue'

export default {
  name: 'MemberNavbar',
  components: {
    BaseNavbar,
  },

  data() {
    return {
      navigation: [
        {
          name: 'マニュアル管理',
          to: {
            name: 'ManageManualList',
          },
        },
        {
          name: 'カテゴリー管理',
          to: {
            name: 'ManageCategoryList',
          },
        },
        {
          name: 'ユーザー管理',
          to: {
            name: 'ManageUserList',
          },
        },
      ],
    }
  },
}
</script>
